import type { ReactNode } from 'react';

import type { ClassValue } from 'clsx';
import { clsx } from 'clsx';

export interface SidebarSectionProps {
    title?: string;
    children: ReactNode;
    className?: ClassValue;
    dataTestid?: string;
    isCollapsed?: boolean;
}

export const SidebarSection = ({
    title,
    children,
    className,
    dataTestid = 'sidebar-section',
    isCollapsed = false,
}: SidebarSectionProps) => (
    <li
        className={clsx('list-none pl-2', className)}
        data-testid={dataTestid}
        data-component-name='SidebarSection'
    >
        {title && !isCollapsed && (
            <span className='block pl-1.5 pr-3.5 pb-1 pt-2.5 mt-1 text-xs font-bold uppercase text-sidebar-foreground/60 border-t border-solid border-sidebar-foreground/10'>
                {title}
            </span>
        )}
        <ul className='flex flex-col'>{children}</ul>
    </li>
);
